import { memo, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LandingLayout from 'containers/layouts/LandingLayout';
import CancelSubscription from 'components/CancelSubscription';
import EmailSent from 'components/CancelSubscription/EmailSent';
import { useTranslationEditorContext } from 'providers/TranslationEditor';
import { LandingContentContainer } from 'containers/layouts/LandingLayout/styled';
import { LoggedUserProps } from 'types/auth';
import Breadcrumb from 'components/Breadcrumb';
import { canonicalLink } from 'utils/seo';
import { LINKS } from 'constants/constants';
import { Container, Header, Title, Subtitle, Wrapper } from './styled';

const CancelSubscriptionContainer: FC<LoggedUserProps> = ({ isLogged }) => {
  const { t, i18n } = useTranslation();
  const { getDataAttributes } = useTranslationEditorContext();
  const [isSent, setSent] = useState(false);

  const breadcrumbItems = [
    {
      dataAttributes: getDataAttributes('qr.breadcrumb.cancelsubscription'),
      title: t('qr.breadcrumb.cancelsubscription', 'Cancel subscription'),
      path: canonicalLink(LINKS.CANCEL_SUBSCRIPTION, false, i18n.language),
    },
  ];

  return (
    <LandingLayout noBGImage keepWidth isLogged={isLogged}>
      <LandingContentContainer>
        <Wrapper>
          <Breadcrumb items={breadcrumbItems} />
          <Container>
            <Header>
              <Title {...getDataAttributes('qr.cancelSubscription.title')}>
                {t('qr.cancelSubscription.title', 'Cancel Subscription')}
              </Title>
              <Subtitle {...getDataAttributes('qr.cancelSubscription.subtitle')}>
                {t(
                  'qr.cancelSubscription.subtitle',
                  'Easily cancel your subscription with the email used to register with us.'
                )}
              </Subtitle>
            </Header>
            {isSent ? <EmailSent /> : <CancelSubscription onSent={setSent} />}
          </Container>
        </Wrapper>
      </LandingContentContainer>
    </LandingLayout>
  );
};

export default memo(CancelSubscriptionContainer);
